import React, { useState, useEffect, useCallback } from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import { any, isEmpty, propEq, equals } from "ramda";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { notBlank, notEmpty } from "../../util/ext";

const useStyles = toolbarHeight =>
  makeStyles(theme => ({
    toolbar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: toolbarHeight ? toolbarHeight : 60,
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "white",
      backgroundColor: "white",
      color: theme.palette.primary.main,
      padding: theme.spacing(4),
    },

    leftContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      // minWidth: 200,
    },

    rightContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      flexGrow: 1,
    },

    title: {
      flexGrow: 1,
      display: "flex",
      alignItems: "center",
      fontSize: "1.2rem",
    },

    count: {
      color: theme.palette.primary.brandPrimary,
      marginRight: 10,
      fontSize: "24px",
      lineHeight: "34px",
      fontWeight: "700",
    },

    typeFacet: {
      color: theme.palette.primary.darker,
      textTransform: "capitalize",
      fontSize: "1.2rem",
    },

    selected: {
      color: theme.palette.primary.main,
      fontWeight: "bolder",
    },
  }));

const TotalsHeader = props => {
  const {
    count,
    showCount = true,
    countText,
    contentTypes,
    contentTypeTerms,
    onContentTypeSelected,
    onClear,
    selectedActions,
    title,
    toolbarHeight,
  } = props;

  const classes = useStyles(toolbarHeight)();

  const handleContentTypeSelected = useCallback(
    term => {
      onContentTypeSelected(term);
    },
    [onContentTypeSelected],
  );

  const handleClearContentTypes = useCallback(() => {
    onClear();
  }, [onClear]);

  const [countTitle, setCountTitle] = useState(countText);
  useEffect(() => {
    if (countText === "Anthology") {
      setCountTitle(equals(count, 1) ? countText : "Anthologies");
    } else {
      setCountTitle(equals(count, 1) ? countText : `${countText}s`);
    }
  }, [count, countText]);

  return (
    <div>
      <div className={classes.toolbar}>
        <div className={classes.leftContainer}>
          {showCount && (
            <div className={classes.title}>
              <div className={classes.count}>{count.toLocaleString()}</div>
              <div className={classes.count}>{countTitle}</div>
            </div>
          )}
        </div>

        {notBlank(contentTypes) && (
          <div className={classes.rightContainer}>
            <Button
              className={clsx(classes.typeFacet, {
                [classes.selected]: isEmpty(contentTypeTerms),
              })}
              variant="text"
              onClick={handleClearContentTypes}
            >
              All
            </Button>

            {notEmpty(contentTypes) &&
              contentTypes.terms.map(term => (
                <Button
                  key={"content-type-facet-term-" + term.label}
                  className={clsx(classes.typeFacet, {
                    [classes.selected]: any(
                      propEq("label", term.label),
                      contentTypeTerms,
                    ),
                  })}
                  variant="text"
                  onClick={() => handleContentTypeSelected(term)}
                >
                  {term.label} ({term.count.toLocaleString()})
                </Button>
              ))}
          </div>
        )}

        <Typography variant="h1" style={{ fontWeight: "700" }}>
          {title && title}
        </Typography>

        <div>{selectedActions && selectedActions}</div>
      </div>
    </div>
  );
};

export default TotalsHeader;
